{
  "chat.add.adding": "Adding…",
  "chat.add.doneMany": "Added {count} people to #{name}",
  "chat.add.doneOne": "Added {person} to #{name}",
  "chat.add.heading": "Add people to #{name}",
  "chat.add.label": "People",
  "chat.add.subtitle": "Pick the people from this workspace who should join.",
  "chat.answer.attachment": "Attachment",
  "chat.answer.failed": "Could not load the chat.",
  "chat.answer.noChannel": "No conversation matches.",
  "chat.answer.noMessages": "No messages here yet.",
  "chat.answer.noUnread": "No unread messages.",
  "chat.answer.unreadCount": "{count} unread",
  "chat.call.channelCallName": "{name} · call",
  "chat.call.channelName": "Channel call",
  "chat.call.directName": "Direct call",
  "chat.channel.channelFallback": "channel",
  "chat.channel.directMessage": "Direct message",
  "chat.channel.fallback": "Chat",
  "chat.channel.groupDm": "Group DM",
  "chat.composer.attachFile": "Attach file",
  "chat.composer.broadcastCaption": "Notify everyone in this channel",
  "chat.composer.cancelEdit": "Cancel edit",
  "chat.composer.cancelReply": "Cancel reply",
  "chat.composer.editing": "Editing message",
  "chat.composer.emoji": "Emoji",
  "chat.composer.formatBold": "Bold",
  "chat.composer.formatBulleted": "Bulleted list",
  "chat.composer.formatCode": "Code",
  "chat.composer.formatHeading": "Heading — click for H1",
  "chat.composer.formatHeading1": "Heading 1 — click for H2",
  "chat.composer.formatHeading2": "Heading 2 — click for H3",
  "chat.composer.formatHeading3": "Heading 3 — click to clear",
  "chat.composer.formatItalic": "Italic",
  "chat.composer.formatLink": "Link",
  "chat.composer.formatNumbered": "Numbered list",
  "chat.composer.formatQuote": "Blockquote",
  "chat.composer.formatRule": "Horizontal rule",
  "chat.composer.formatStrike": "Strikethrough",
  "chat.composer.formatUnderline": "Underline",
  "chat.composer.mention": "Mention someone",
  "chat.composer.messageAria": "Message",
  "chat.composer.messageChannel": "Message #{name}",
  "chat.composer.notifyAllConfirm": "Send",
  "chat.composer.notifyAllMessage": "Everyone in this channel will get a mention notification.",
  "chat.composer.notifyAllTitle": "Notify all {count} members?",
  "chat.composer.retry": "Retry",
  "chat.composer.send": "Send message",
  "chat.drawer.channels": "Channels",
  "chat.drawer.close": "Close",
  "chat.drawer.noChannels": "No channels available.",
  "chat.empty.heading": "Welcome to Chat",
  "chat.empty.hint": "Select a channel from the sidebar to read the latest updates, or click a teammate to start a direct message.",
  "chat.empty.noMessages": "No messages yet — say something.",
  "chat.error.addMembersTitle": "Could not add members",
  "chat.error.alreadyMemberMessage": "#{name} already exists — you're already a member instead of a new, separate channel.",
  "chat.error.alreadyMemberTitle": "Already in this channel",
  "chat.error.deleteMessageTitle": "Could not delete message",
  "chat.error.editMessageTitle": "Could not save the edit",
  "chat.error.joinedExistingMessage": "#{name} already exists — you're now a member instead of a new, separate channel.",
  "chat.error.joinedExistingTitle": "Joined existing channel",
  "chat.error.nameTakenMessage": "A private channel named #{name} already exists. Ask its owner to add you, or pick a different name.",
  "chat.error.nameTakenTitle": "Channel name already taken",
  "chat.error.networkMessage": "Network or server error — try again.",
  "chat.error.networkShort": "Network or server error",
  "chat.error.openChatTitle": "Could not open chat",
  "chat.error.reactionTitle": "Could not update reaction",
  "chat.error.removeMemberTitle": "Could not remove the member",
  "chat.error.sendTitle": "Message failed to send",
  "chat.error.stillSending": "This message is still sending — wait a moment, then try again.",
  "chat.error.ticketNotFoundMessage": "#{ref} may have been deleted, or is not in this workspace.",
  "chat.error.ticketNotFoundTitle": "Ticket not found",
  "chat.error.tryAgain": "Please try again",
  "chat.error.uploadMessage": "Could not upload the file",
  "chat.error.uploadShort": "Upload failed",
  "chat.error.uploadTitle": "Attachment upload failed",
  "chat.header.activeNow": "Active now",
  "chat.header.callAll": "Call all participants",
  "chat.header.callFailedMessage": "Could not load the call surface. Refresh and try again.",
  "chat.header.callFailedTitle": "Call failed",
  "chat.header.closeCall": "Close call",
  "chat.header.memberMany": "{count} members",
  "chat.header.memberOne": "1 member",
  "chat.header.more": "More options",
  "chat.header.peopleCount": "{count} people",
  "chat.header.search": "Search in this conversation",
  "chat.header.selectChannel": "Select a channel",
  "chat.header.viewMembers": "View members",
  "chat.intro.addPeople": "Add people",
  "chat.intro.channelPrivate": "This is the very beginning of {name}. Only its members can read it.",
  "chat.intro.channelPublic": "This is the very beginning of #{name}. Everyone in the workspace can read it.",
  "chat.intro.dm": "This is the beginning of your conversation with {name}.",
  "chat.intro.groupDm": "This is the beginning of your group conversation.",
  "chat.intro.viewProfile": "View profile",
  "chat.list.jumpToLatest": "Jump to latest",
  "chat.list.newDivider": "New",
  "chat.list.newMessages": "New messages",
  "chat.mention.suggestions": "Mention suggestions",
  "chat.menu.createChannel": "Create channel",
  "chat.menu.hide": "Hide",
  "chat.menu.invite": "Invite",
  "chat.menu.leave": "Leave",
  "chat.menu.message": "Message",
  "chat.menu.mute": "Mute",
  "chat.menu.pinToTop": "Pin to top",
  "chat.menu.rename": "Rename",
  "chat.menu.scheduleMeeting": "Schedule meeting",
  "chat.menu.settings": "Settings",
  "chat.menu.startGroupChat": "Start group chat",
  "chat.menu.unmute": "Unmute",
  "chat.menu.unpin": "Unpin",
  "chat.menu.viewProfile": "View profile",
  "chat.message.actions": "Message actions",
  "chat.message.addReaction": "Add a reaction",
  "chat.message.bookmark": "Bookmark",
  "chat.message.copyUrl": "Copy URL",
  "chat.message.createEvent": "Create event",
  "chat.message.createKb": "Create knowledge base",
  "chat.message.createNote": "Create note",
  "chat.message.createTask": "Create task",
  "chat.message.delete": "Delete message",
  "chat.message.deleteConfirm": "Delete",
  "chat.message.deleteConfirmMessage": "The message is removed for everyone in this conversation.",
  "chat.message.deleteConfirmTitle": "Delete this message?",
  "chat.message.edit": "Edit message",
  "chat.message.edited": "edited",
  "chat.message.forward": "Forward",
  "chat.message.jumpToReplied": "Jump to replied message",
  "chat.message.moreActions": "More actions",
  "chat.message.moreReactions": "More reactions",
  "chat.message.originalUnavailable": "Original message unavailable",
  "chat.message.pin": "Pin",
  "chat.message.reply": "Reply",
  "chat.message.replyInThread": "Reply in thread",
  "chat.message.untitledArticle": "Untitled article",
  "chat.message.untitledEvent": "Untitled event",
  "chat.message.untitledNote": "Untitled note",
  "chat.new.cancel": "Cancel",
  "chat.new.headingChannel": "Create channel",
  "chat.new.headingDm": "New direct message",
  "chat.new.kindChannel": "# Channel",
  "chat.new.kindDm": "Direct message",
  "chat.new.kindLabel": "Conversation type",
  "chat.new.members": "Members",
  "chat.new.name": "Name",
  "chat.new.namePlaceholder": "e.g. design-reviews",
  "chat.new.searchPlaceholder": "Search teammates…",
  "chat.new.submitChannel": "Create channel",
  "chat.new.submitDm": "Open DM",
  "chat.new.subtitleChannel": "Pick a name and add the people who should join",
  "chat.new.subtitleDm": "Pick one or more people to message",
  "chat.new.topic": "Topic (optional)",
  "chat.new.topicPlaceholder": "What is this channel about?",
  "chat.notify.mentionedEveryone": "{sender} mentioned everyone in #{channel}",
  "chat.notify.mentionedYou": "{sender} mentioned you in #{channel}",
  "chat.overlay.chats": "Chats",
  "chat.overlay.closeChats": "Close chats",
  "chat.overlay.closeConversation": "Close conversation",
  "chat.overlay.switchView": "Switch view",
  "chat.page.chat.title": "Chat",
  "chat.picker.clearSelection": "Clear selection",
  "chat.picker.everyoneIn": "Everyone in this workspace is already in this channel.",
  "chat.picker.noMatches": "No matches",
  "chat.picker.noPeople": "No teammates to pick yet.",
  "chat.picker.noneSelected": "No one selected yet",
  "chat.picker.removePerson": "Remove {name}",
  "chat.picker.selectAll": "Select all",
  "chat.picker.selectedCount": "{count} selected",
  "chat.rename.cancel": "Cancel",
  "chat.rename.heading": "Rename channel",
  "chat.rename.placeholder": "Channel name",
  "chat.rename.save": "Save",
  "chat.rename.subtitle": "Give this conversation a clearer name",
  "chat.search.heading": "Search messages",
  "chat.search.hint": "Type to search messages across every channel you belong to.",
  "chat.search.noMatches": "No matches for \"{query}\"",
  "chat.search.placeholder": "Search all messages…",
  "chat.search.subtitle": "Search across every channel you belong to.",
  "chat.settings.archive": "Archive",
  "chat.settings.archiveChannel": "Archive channel",
  "chat.settings.archiveConfirmTitle": "Archive {target}?",
  "chat.settings.archiveMessage": "Archived channels are hidden from the sidebar. Members can unarchive later.",
  "chat.settings.channelFallback": "channel",
  "chat.settings.conversationFallback": "conversation",
  "chat.settings.delete": "Delete",
  "chat.settings.deleteChannel": "Delete channel",
  "chat.settings.deleteConfirmMessage": "This permanently removes the channel and all of its messages for every member. This cannot be undone.",
  "chat.settings.deleteConfirmTitle": "Delete #{name}?",
  "chat.settings.eventFallback": "Event",
  "chat.settings.linkEventNone": "Link to calendar event…",
  "chat.settings.linkedEvent": "Linked event / call",
  "chat.settings.members": "Members",
  "chat.settings.muteHint": "Mute notifications — no bell, dimmed unread badge.",
  "chat.settings.name": "Name",
  "chat.settings.namePlaceholder": "e.g. design-reviews",
  "chat.settings.noMembers": "No members loaded yet.",
  "chat.settings.privateHint": "Private channel — only invited members can see messages.",
  "chat.settings.removeConfirmMessage": "They lose access to this channel. You can add them again later.",
  "chat.settings.removeConfirmTitle": "Remove {name} from #{channel}?",
  "chat.settings.removeMember": "Remove from channel",
  "chat.settings.save": "Save",
  "chat.settings.searchPlaceholder": "Search teammates to add…",
  "chat.settings.subtitleChannel": "Manage the name, topic, privacy, and members.",
  "chat.settings.subtitleConversation": "Manage notifications, linked events, and members.",
  "chat.settings.titleChannel": "#{name} settings",
  "chat.settings.titleConversation": "{name} settings",
  "chat.settings.titleDm": "Conversation settings",
  "chat.settings.titleFallback": "Settings",
  "chat.settings.topic": "Topic",
  "chat.settings.topicPlaceholder": "What is this channel about?",
  "chat.settings.unarchive": "Unarchive",
  "chat.settings.unarchiveChannel": "Unarchive channel",
  "chat.settings.unarchiveConfirmTitle": "Unarchive {target}?",
  "chat.settings.unarchiveMessage": "The channel will appear in the sidebar again.",
  "chat.settings.youName": "{name} (you)",
  "chat.sidebar.add": "Add",
  "chat.sidebar.channels": "CHANNELS",
  "chat.sidebar.conversations": "Conversations",
  "chat.sidebar.directMessages": "DIRECT MESSAGES",
  "chat.sidebar.externalPeople": "EXTERNAL PEOPLE",
  "chat.sidebar.groups": "GROUPS",
  "chat.sidebar.newChannel": "New channel",
  "chat.sidebar.newExternalMessage": "New external message",
  "chat.sidebar.newGroup": "New group",
  "chat.sidebar.newMessage": "New message",
  "chat.sidebar.pinned": "PINNED",
  "chat.sidebar.resize": "Resize sidebar",
  "chat.tab.allAuthors": "All authors",
  "chat.tab.attachments": "📎 Attachments",
  "chat.tab.clear": "Clear",
  "chat.tab.conversation": "Conversation",
  "chat.tab.files": "Files",
  "chat.tab.filterPlaceholder": "Filter messages in this channel…",
  "chat.tab.goToMessage": "Go to message",
  "chat.tab.links": "Links",
  "chat.tab.mentions": "@ Mentions",
  "chat.tab.noFiles": "No files shared in this channel yet.",
  "chat.tab.noLinks": "No links shared in this channel yet.",
  "chat.tab.noTasks": "No tasks referenced in this channel yet. Use #PROJECT-123 syntax to link tasks.",
  "chat.tab.tickets": "Tasks",
  "chat.thread.close": "Close thread",
  "chat.thread.heading": "Thread",
  "chat.thread.noReplies": "No replies yet",
  "chat.thread.placeholder": "Reply to thread…",
  "chat.thread.replyMany": "{count} replies",
  "chat.thread.replyOne": "1 reply",
  "chat.typing.many": "Several people are typing",
  "chat.typing.one": "{name} is typing",
  "chat.typing.two": "{a} and {b} are typing"
}
